import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { STVMDigitalAction } from './stvm-digital.action';
import { share, switchMap, map, catchError } from 'rxjs/operators';
import { STVMDigitalService } from '@hub-workspace/apps/logged-home/src/app/shared/services/stvm-digital/stvm-digital.service';
import { ISTVMDigitalPortability } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/stvm-digital.interface';

@Injectable()
export class STVMDigitalEffects {
  constructor(
    private actions$: Actions<STVMDigitalAction>,
    private stvmDigitalService: STVMDigitalService
  ) {}

  public getPortabilities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STVMDigitalAction.getPortabilities),
      switchMap(() =>
        this.stvmDigitalService.getPortabilities().pipe(
          map((payload) => ({
            payload,
            type: STVMDigitalAction.getPortabilitiesSuccess,
          })),
          catchError(({ message }) =>
            of({
              type: STVMDigitalAction.getPortabilitiesError,
              payload: message,
            })
          )
        )
      ),
      share()
    )
  );

  public acceptPortability$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STVMDigitalAction.acceptPortability),
      switchMap((action) =>
        this.stvmDigitalService
          .acceptPortability(action.payload as ISTVMDigitalPortability)
          .pipe(
            map((payload) => ({
              payload: { payload, action },
              type: STVMDigitalAction.acceptPortabilitySuccess,
              portabilities: action.portabilities,
            })),
            catchError(({ message }) =>
              of({
                type: STVMDigitalAction.acceptPortabilityError,
                payload: message,
              })
            )
          )
      ),
      share()
    )
  );
}
